import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { Operator } from '../../../../../graphql'

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-operator-logo',
    templateUrl: 'operator-logo.html'
})
export class OperatorLogoComponent {
    @Input() width: number | undefined
    @Input() height: number | undefined
    @Input() operator: Operator | undefined
}
